import { EntityId } from '@Models';
import { RequestDataSuccess } from '@Repository/RequestAction';
import { Result } from './type';
import { container } from '@Container';
import { Locale } from '@Repository/locale';
import { TYPES } from '@Types';
import { DeleteRepository } from '@Repository/DeleteRepository';
import { IEntityAction } from '@Redux/IEntityAction';

export abstract class IEditableEntityAction<
  I extends string | number,
  T extends EntityId<I>,
  Q extends RequestDataSuccess<T>,
> extends IEntityAction<I, T, Q> {
  public delete =
    (id: I): Result<void> =>
    async (dispatch) => {
      dispatch(this.areLoading(true));

      const response = await this.getDeleteRepository().delete({
        id: id,
        locale: null,
      });

      if (this.handleFailure(response, dispatch)) return;

      const locale = container.get<Locale>(TYPES.Locale);
      window.location.href = `/${locale.getlocale()}/builder/army_lists`;
    };

  abstract getDeleteRepository(): DeleteRepository<I>;
}
